import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux'; 

import Leads from './index';

export function DealLeadsTab({ leadsTabProps }) {
  return (
    <Leads {...leadsTabProps}/>
  );
}

DealLeadsTab.propTypes = {
  leadsTabProps: PropTypes.object
};

const mapStateToProps = state => ({
  leadsTabProps: state.leadsTabProps
});

export default connect(mapStateToProps)(DealLeadsTab);